"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@dzambalaorg/constants");
const types_1 = require("@framework/types");
exports.validationSchema = (0, yup_1.object)().shape({
    parameterName: (0, yup_1.string)().required("form.validations.valueMissing"),
    parameterType: (0, yup_1.mixed)().oneOf(Object.values(types_1.ParameterType)).required("form.validations.valueMissing"),
    parameterValue: (0, yup_1.mixed)().when("parameterType", {
        is: (parameterType) => parameterType === types_1.ParameterType.ENUM,
        then: () => (0, yup_1.string)().required("form.validations.valueMissing"),
        otherwise: () => (0, yup_1.string)().notRequired(),
    }),
    parameterMinValue: (0, yup_1.mixed)()
        .when("parameterType", {
        is: (parameterType) => parameterType === types_1.ParameterType.NUMBER || parameterType === types_1.ParameterType.STRING,
        then: () => (0, yup_1.string)().notRequired(),
    })
        .when("parameterType", {
        is: (parameterType) => parameterType === types_1.ParameterType.DATE,
        then: () => (0, yup_1.string)().matches(constants_1.reISO8601, "form.validations.patternMismatch").required("form.validations.valueMissing"),
        otherwise: () => (0, yup_1.mixed)().notRequired(),
    }),
    parameterMaxValue: (0, yup_1.mixed)()
        .when("parameterType", {
        is: (parameterType) => parameterType === types_1.ParameterType.NUMBER || parameterType === types_1.ParameterType.STRING,
        then: () => (0, yup_1.string)().notRequired(),
    })
        .when("parameterType", {
        is: (parameterType) => parameterType === types_1.ParameterType.DATE,
        then: () => (0, yup_1.string)().matches(constants_1.reISO8601, "form.validations.patternMismatch").required("form.validations.valueMissing"),
        otherwise: () => (0, yup_1.string)().notRequired(),
    }),
});
//# sourceMappingURL=validation.js.map